export class GraphErrors extends Error {
  constructor(public readonly key: string) {
    super();
    this.name = 'GraphErrors';
  }
}
